import React, { useState } from 'react';
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';

const ShowMoreLess = (props) => {
    const { translation:t } = System;
    const { single_product, no_show_more } = props;
    const { DescriptionLength: { More, Less } } = Constants
    const [action_here, set_action_here] = useState(More);
    const defaultDescLength = 100;
    let shortDescription = single_product.ShortDescription ? (single_product.ShortDescription.length > defaultDescLength ? single_product.ShortDescription.substring(0, defaultDescLength) : single_product.ShortDescription) : '';

    return (
        <>
            {action_here === More && single_product && shortDescription != '' && (single_product.ShortDescription && single_product.ShortDescription.length > defaultDescLength) && !no_show_more
                ?
                <p className="mob-font-13">{shortDescription}<a
                    onClick={(e) => {
                        e.stopPropagation();
                        set_action_here(Less)
                    }}
                    className="more-link"> …
                    {t('more')}</a>
                </p> : <p className="mob-font-13">{single_product.ShortDescription}</p>}
        </>
    );

};

export default ShowMoreLess;